export default __webpack_public_path__ + "static/media/follow.cbd71d99.svg";